import styles from './Choice.module.css'; 

interface ChoiceProps {
  text: string
  onClick: () => void
}

function Choice(props: ChoiceProps) {
  return (
    <button className={styles.Choice} onClick={props.onClick}>{props.text}</button>
  );
}

export default Choice;
